import { render } from "./TheTrigger.vue?vue&type=template&id=13477867"
import script from "./TheTrigger.vue?vue&type=script&lang=js"
export * from "./TheTrigger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__